import { Link } from 'react-router-dom';

export default function MilitaryDiscountCallout() {
  return (
    <section className="py-16 bg-[#F7F5F0]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
          <div className="grid md:grid-cols-2 gap-0">
            {/* Left Side - Content */}
            <div className="p-6 sm:p-8 lg:p-12 flex flex-col justify-center">
              <div className="inline-flex items-center gap-2 bg-[#E8B84B]/15 text-[#92650a] px-4 py-2 rounded-full text-sm font-semibold mb-5 w-fit">
                <i className="ri-shield-star-line text-lg"></i>
                <span>Honoring Those Who Serve</span>
              </div>
              
              <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[#1C2B1E] mb-4">
                Dog Tag Discount
              </h2>
              
              <p className="text-base sm:text-lg text-[#374151] mb-5 leading-relaxed">
                We're proud to offer a <strong className="text-[#1C2B1E]">$300 discount</strong> to active duty service members, veterans, reservists, and their spouses. But here's what makes it special — you choose how to use it.
              </p>
              
              <div className="space-y-4 mb-6">
                <div className="flex items-start gap-3">
                  <div className="w-9 h-9 rounded-full bg-[#E8B84B]/15 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-price-tag-3-line text-[#92650a] text-base"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-[#1C2B1E] mb-1 text-sm sm:text-base">Take $300 Off Your Vehicle</h3>
                    <p className="text-[#4A5568] text-sm">Apply the discount directly to your purchase price.</p>
                  </div>
                </div>
                
                <div className="flex items-start gap-3">
                  <div className="w-9 h-9 rounded-full bg-[#E8B84B]/15 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-heart-line text-[#92650a] text-base"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-[#1C2B1E] mb-1 text-sm sm:text-base">Donate to Your Charity of Choice</h3>
                    <p className="text-[#4A5568] text-sm">Direct the $300 to any registered 501(c)(3) charity that matters to you — veteran support organizations, animal welfare, local community groups, or any cause you care about.</p>
                  </div>
                </div>
              </div>
              
              <Link
                to="/military-discount"
                className="inline-flex items-center justify-center gap-2 bg-[#1C2B1E] text-white px-6 py-3 rounded-lg font-semibold hover:bg-[#2d4430] transition-colors whitespace-nowrap w-full sm:w-fit text-sm sm:text-base"
              >
                <span>Learn More About the Dog Tag Discount</span>
                <i className="ri-arrow-right-line text-lg"></i>
              </Link>
            </div>
            
            {/* Right Side - Visual */}
            <div className="relative bg-gradient-to-br from-[#1C2B1E] to-[#2d4430] p-8 lg:p-12 flex flex-col justify-center items-center text-white">
              <div className="absolute inset-0 opacity-10">
                <div className="absolute inset-0" style={{
                  backgroundImage: 'repeating-linear-gradient(45deg, transparent, transparent 10px, rgba(255,255,255,0.1) 10px, rgba(255,255,255,0.1) 20px)'
                }}></div>
              </div>
              
              <div className="relative z-10 text-center w-full">
                <div className="w-16 h-16 sm:w-20 sm:h-20 mx-auto mb-4 rounded-full bg-[#E8B84B]/20 flex items-center justify-center">
                  <i className="ri-flag-line text-4xl sm:text-5xl text-[#E8B84B]"></i>
                </div>
                
                <div className="mb-6">
                  <div className="text-5xl sm:text-6xl font-bold text-[#E8B84B] mb-2">$300</div>
                  <div className="text-base sm:text-xl font-semibold text-white/80">Your Choice, Your Impact</div>
                </div>
                
                <div className="space-y-2 text-left max-w-xs mx-auto">
                  <div className="flex items-center gap-3 bg-white/10 backdrop-blur-sm rounded-lg p-3">
                    <i className="ri-checkbox-circle-fill text-xl text-[#E8B84B]"></i>
                    <span className="text-sm font-medium">Active Duty &amp; Veterans</span>
                  </div>
                  <div className="flex items-center gap-3 bg-white/10 backdrop-blur-sm rounded-lg p-3">
                    <i className="ri-checkbox-circle-fill text-xl text-[#E8B84B]"></i>
                    <span className="text-sm font-medium">Reservists &amp; National Guard</span>
                  </div>
                  <div className="flex items-center gap-3 bg-white/10 backdrop-blur-sm rounded-lg p-3">
                    <i className="ri-checkbox-circle-fill text-xl text-[#E8B84B]"></i>
                    <span className="text-sm font-medium">Military Spouses</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
